import { render, staticRenderFns } from "./doubleConfirmation.vue?vue&type=template&id=2c8d4135&scoped=true"
import script from "./doubleConfirmation.vue?vue&type=script&lang=js"
export * from "./doubleConfirmation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8d4135",
  null
  
)

export default component.exports